var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 69,
    viewBox: "0 0 62 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M37 69C50.8071 69 62 57.8071 62 44C62 30.1929 50.8071 19 37 19C23.1929 19 12 30.1929 12 44C12 57.8071 23.1929 69 37 69Z",
    fill: "#8AC43F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92085 44.1754V47.5332H1.34863V39.6573C1.55928 40.7357 1.85666 41.8004 2.19121 42.7695C2.48859 43.6158 3.23204 44.1754 4.06223 44.1754H5.92085Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0312 39.6708V47.533H31.459V44.1752H33.3176C34.1478 44.1752 34.8912 43.6155 35.1886 42.7693C35.5232 41.8138 35.8206 40.7491 36.0312 39.6708Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7388 31.8353L29.0798 20.6835C21.3231 18.5814 16.119 18.5541 8.30035 20.6835L3.629 31.8353C0.853456 32.2311 0.630421 36.0121 1.34909 39.6566C1.55973 40.7349 1.85711 41.7996 2.19167 42.7687C2.48905 43.615 3.2325 44.1746 4.06268 44.1746H13.6284V43.1236C13.6284 42.796 13.8638 42.5367 14.1488 42.5367H23.2189C23.5163 42.5367 23.7517 42.796 23.7517 43.1236V44.1746H33.3175C34.1476 44.1746 34.8911 43.615 35.1885 42.7687C35.523 41.8132 35.8204 40.7486 36.0311 39.6702C36.7497 36.0258 36.5391 32.2311 33.7388 31.8353ZM6.71432 30.3611L9.78725 22.5398C15.1029 21.5161 21.4223 21.3523 27.5929 22.5398L30.6658 30.3611H6.71432Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7895 40.2037H13.5795L12.6006 34.894H24.7808L23.7895 40.2037Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7512 43.123V45.2387C23.7512 45.5663 23.5158 45.812 23.2184 45.812H14.1483C13.8634 45.812 13.6279 45.5663 13.6279 45.2387V43.123C13.6279 42.7954 13.8634 42.5361 14.1483 42.5361H23.2184C23.5158 42.5361 23.7512 42.7954 23.7512 43.123Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0502 37.4053C11.0502 38.2516 10.4307 38.9341 9.66242 38.9341H5.58583C4.28479 38.9341 3.82633 38.0332 3.72721 37.0777C3.59091 35.8902 4.44588 34.8528 5.52388 34.8528H8.52246C9.22874 34.8528 9.89785 35.2214 10.3315 35.8492L10.7652 36.4908C10.9511 36.7501 11.0502 37.0641 11.0502 37.4053Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3154 37.4053C26.3154 38.2516 26.935 38.9341 27.7032 38.9341H31.7798C33.0808 38.9341 33.5393 38.0332 33.6384 37.0777C33.7747 35.8902 32.9197 34.8528 31.8294 34.8528H28.8308C28.1245 34.8528 27.4554 35.2214 27.0217 35.8492L26.588 36.4908C26.4146 36.7501 26.3154 37.0641 26.3154 37.4053Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9007 31.837C46.2974 29.7796 45.105 27.7574 43.2374 27.3204C41.3697 26.8833 39.5341 28.1969 39.1373 30.2543C38.7406 32.3117 39.933 34.3338 41.8006 34.7709C43.6683 35.2079 45.5039 33.8944 45.9007 31.837Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8037 42.1957C44.8037 43.2877 43.9983 44.1886 42.9946 44.1886C42.0033 44.1886 41.1855 43.3013 41.1855 42.1957C41.1855 41.1037 41.991 40.2029 42.9946 40.2029C43.9983 40.2029 44.8037 41.0901 44.8037 42.1957Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0105 7.75661C50.5273 4.56258 47.4791 2.67892 44.7407 3.89374C43.638 2.14658 41.8041 1 39.7348 1C37.0584 1 34.8033 2.89731 33.9731 5.53171C30.2682 5.32696 27.3936 8.56195 27.3936 12.3839C27.3936 17.6936 32.6225 20.9559 36.7486 18.3351C37.6656 21.6384 40.4535 24.0544 43.7495 24.0544C47.2189 24.0544 50.1308 21.3927 50.8742 17.8165C56.289 17.2159 56.4129 8.50735 51.0105 7.75661Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8663 15.5364C43.0502 15.5364 44.0099 13.9842 44.0099 12.0694C44.0099 10.1546 43.0502 8.60239 41.8663 8.60239C40.6824 8.60239 39.7227 10.1546 39.7227 12.0694C39.7227 13.9842 40.6824 15.5364 41.8663 15.5364Z",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4548 14.5264C37.0707 15.1543 36.5255 15.5364 35.9307 15.5364C34.7412 15.5364 33.7871 13.9804 33.7871 12.0694C33.7871 10.1585 34.7536 8.60239 35.9307 8.60239C36.5255 8.60239 37.0583 8.98458 37.4424 9.61247",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7705 7.89321C45.7705 7.34722 46.167 6.91043 46.6626 6.91043C47.1583 6.91043 47.5548 7.34722 47.5548 7.89321C47.5548 8.94424 46.6626 8.72584 46.2042 9.18993C45.9935 9.39468 45.7953 9.74957 45.7829 10.3092H47.5424",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34863 48.6374H42.5234",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9971 51H44.8041",
    stroke: "#3F3F3F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.809fa6b5edc34d51e3e89f8b3dbd20a5.svg";
export { ForwardRef as ReactComponent };